import {
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  useDisclosure,
  AmplifyIcon,
} from '@cdl/heartbeat-react';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { gainSelector } from '../layout/selectors/layout.selectors';
import * as layoutActions from '../layout/actions/layout.actions';
import { ToolButton } from '../../features/tool/components/ToolButton';

const WIDTH = '5rem';

const AMPLITUDE_MAPPING: Record<string, number> = {
  'x 4': 4,
  'x 2': 2,
  'x 1': 1,
  'x ½': 0.5,
};

export const AmplitudeTool: React.FC = () => {
  const dispatch = useDispatch();
  const gain = useSelector(gainSelector);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const onChangeAmplitude = useCallback(
    (amplitude: string) => {
      dispatch(
        layoutActions.update({
          update: { gain: AMPLITUDE_MAPPING[amplitude] },
        }),
      );
    },
    [dispatch],
  );

  const selectedValue = useMemo(
    () =>
      Object.keys(AMPLITUDE_MAPPING).find(
        (amplitude) => AMPLITUDE_MAPPING[amplitude] === gain,
      ) as string,
    [gain],
  );

  return (
    <Menu>
      <ToolButton
        as={MenuButton}
        label='Change Amplitude'
        aria-label='Change Amplitude'
        isTooltipOpen={isOpen}
        icon={<AmplifyIcon />}
        onClick={onClose}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
      />
      <MenuList minWidth='unset' width={WIDTH}>
        <MenuOptionGroup
          type='radio'
          onChange={(amplitude) => onChangeAmplitude(amplitude as string)}
          value={selectedValue}
        >
          {Object.keys(AMPLITUDE_MAPPING).map((amplitude) => (
            <MenuItemOption
              key={amplitude}
              value={amplitude}
              onClick={() => onChangeAmplitude(amplitude)}
            >
              {amplitude}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
